export const APIKey = '0dd5542d536e51ce47540ed11c8f0ebc';

export const openweather = {
    openweather: {
        apiKey: '0dd5542d536e51ce47540ed11c8f0ebc',
    }
};
